import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { UserContext } from "../userContext"
import Spinner, { ToggleSpinner } from "../components/spinner"
import ForgotPINButton from "./components/forgotPINButton"
import { fetchResource } from "../../methods/fetchResource"
import { generateErrorMessage } from "../../methods/generateErrorMessage"

export default function Login() {
	const [message, setMessage] = useState("")
	const userContext = useContext(UserContext)
	const navigate = useNavigate()
	const [messageIsError, setMessageIsError] = useState(true)
	const [buttonsHidden, setButtonsHidden] = useState(false)

	useEffect(() => {
		let registered = userContext.email !== ""

		if (registered) {
			setMessageIsError(false)
			setMessage("Please check your e-mail for your PIN. If you don't receive it momentarily, please check your spam/junk folder.")
			//document.getElementById("scrollHereInitially").scrollIntoView()
		}
	}, [])

	async function onSubmit(event) {
		event.preventDefault()

		setProcessingVisuals()

		setMessageIsError(true)

		let email = document.getElementById("inputEmail").value
		let pin = document.getElementById("inputPin").value

		userContext.email = email.toLowerCase()

		//Try logging in
		let login = await fetchResource("/api/login", {
			email,
			pin,
			parcelID: userContext.parcelID
		})

		if (!login.success) {
			if (login.status === 401) {
				setMessageAndHandleThings("Incorrect e-mail/PIN")
			}
			else {
				setMessageAndHandleThings(generateErrorMessage(login.status))
			}
			return
		}

		//Let's get the name of the primary applicant and have list handy if we need to check for residency
		let applicantsList = await fetchResource(`/api/applicants/list?parcelID=${userContext.parcelID}`)

		if (!applicantsList.success) {
			setMessageAndHandleThings(generateErrorMessage(applicantsList.status))
			return
		}

		if (applicantsList.result.rows.length < 1) {
			setMessageAndHandleThings(generateErrorMessage(51))
			return
		}

		userContext.name = applicantsList.result.rows[0].applicant_name
		applicantsList.result.rows.forEach((applicant) => {
			if (applicant.is_primary) {
				userContext.name = applicant.applicant_name
			}
		})

		//We've logged in, let's see where to go
		//First up, do we have a DocuSign link already? If so, let's redirect to there
		let docusignURL = await fetchResource("/api/docusign/view", {
			parcelID: userContext.parcelID,
			email,
			name: userContext.name
		})

		if (docusignURL.success) {
			if (docusignURL.result !== null) {
				window.open(docusignURL.result.url, "_self")
				return
			}
		}

		if (!docusignURL.success) {
			setMessageAndHandleThings(docusignURL.message)
			return
		}

		//No DocuSign, do they have HX already? If so, go to exemptions for additional HX
		if (userContext.parcelHasHxCode) {
			navigate("/exemptions")
			return
		}

		let userIndicatedHomestead = await fetchResource(`/api/userIndicatedHomestead?parcelID=${userContext.parcelID}`)

		if (!userIndicatedHomestead.success) {
			setMessageAndHandleThings(generateErrorMessage(userIndicatedHomestead.status))
			return
		}

		userContext.user_is_homestead = userIndicatedHomestead.result.is_homestead

		//No HX already, is this their Homestead? If not, go to exemptions for non-HX
		if (!userContext.user_is_homestead) {
			navigate("/exemptions")
			return
		}

		//Can we bypass residency check?
		if (userContext.bypassResidencyDueToApplication) {
			navigate("/exemptions")
			return
		}

		//Check residency to see if we need to validate anyone
		let allValid = true
		applicantsList.result.rows.forEach((applicant) => {
			if (!applicant.residency_valid) {
				allValid = false
				navigate("/residency")
			}
		})

		if (allValid) {
			navigate("/exemptions")
		}
	}

	function setProcessingVisuals() {
		setButtonsHidden(true)
		ToggleSpinner("spinner")
		setMessage("")
	}

	function setMessageAndHandleThings(message) {
		setButtonsHidden(false)
		ToggleSpinner("spinner")

		setMessage(message)

		//document.getElementById("loginMessage").scrollIntoView()
	}

	function setMessageFromPIN(message) {
		setMessage(message)
		//document.getElementById("loginMessage").scrollIntoView()
	}

	return (
		<div id="exemptions-portal--register" className="container">
			<div className="row">
				<div className="col-12">
					<h1 className="h1-style">Log In</h1>
					<div className="bg-navy p-3 rounded mx-auto" style={{maxWidth: "400px"}}>
						<form
							id="loginForm"
							onSubmit={onSubmit}
							className="d-flex flex-column gap-2 mb-2"
						>
							<div className="input-group">
								<label
									htmlFor="inputEmail"
									className="input-group-text justify-content-end"
									style={{width: "80px"}}
								>
									E-mail:
								</label>
								<input
									id="inputEmail"
									type="email"
									required
									defaultValue={userContext.email}
									className="form-control"
								/>
							</div>
							<div className="input-group">
								<label
									htmlFor="inputPin"
									className="input-group-text justify-content-end"
									style={{width: "80px"}}
								>
									PIN:
								</label>
								<input
									id="inputPin"
									type="password"
									required
									className="form-control"
								/>
							</div>
							<input
								id="submitButton"
								className={`btn btn-light ${buttonsHidden ? "d-none" : ""}`}
								type="submit"
								value="Log In"
								disabled={buttonsHidden}
							/>
						</form>
						<ForgotPINButton
							setMessage={setMessageFromPIN}
							setMessageIsError={setMessageIsError}
							buttonsHidden={buttonsHidden}
							setButtonsHidden={setButtonsHidden}
						/>
						<Spinner id="spinner" />
					</div>
					<h2 id="loginMessage" className={`border ${messageIsError ? "bg-danger" : "bg-navy"} text-light px-3 py-2 rounded mt-3 mb-0 ${message === "" ? "d-none" : ""}`}>
						<i className="fa-solid fa-circle-exclamation"></i> {message}
					</h2>
				</div>
			</div>
		</div>
	)
}